/* Итог заказа с автодоставкой на хвосте BotRun шаблона (engine-kit, план M3 §2 S4, D6): подпись итога по доставке, «Открыть в чате»
   и ссылка «Настройки» — те же правила, что у родного хвоста (circle/OrderTail.tsx: deliveryOff, chat, ссылка #settings).
   Готовый результат бот присылает в чат сам; если не присылает (так выбрано в настройках или по другой причине), подпись итога чат
   не обещает: «Результат сохранён в «Истории»…», а при выборе в настройках — ещё и ссылка «Настройки».
   «Открыть в чате» ставит экран (chatFoot: foot.done задан — BotRun своего слушателя data-run-chat не вешает), нажатие — chatClick из
   click экрана: заказ просмотрен, в Telegram мини-приложение закрывается (чат под ним), вне Telegram — подсказка-стекло.
   bot-run-server.ts не меняется (голос). */
import type { SpeechOrder } from '../../../api/speech';
import { uiText } from '../../../i18n';
import { platform } from '../../../platform';
import { markSeen } from '../circle/tool-helpers';
import { studioDeliveryOffText, studioDeliveryView } from '../studio-order-tail-model';
import { esc } from './bot-run-server';

const UNAVAILABLE = 'Файл результата пока недоступен. Проверьте работу в «Истории».';

/** Бот сам не присылает итог готового заказа: подпись вместо подписи экрана; null — действует подпись экрана */
export function deliveryOff(order: SpeechOrder | null | undefined): string | null {
  return order?.status === 'done' ? studioDeliveryOffText(studioDeliveryView(order)) : null;
}

/** T.doneP BotRun (подпись под «… готово»; BotRun вставляет её в <p>…</p>): base — подпись экрана (готовая разметка).
    Бот сам не присылает — текст доставки (экранированный); выбрано в настройках и известна приставка экрана p — после абзаца ссылка
    «Настройки» (data-<p>-settings, нажатие — openSettings); готовый заказ без доступного файла — абзац «Файл результата пока недоступен…»
    (как родной хвост). Разметка закрывает и открывает абзацы так, что BotRun получает те же узлы, что рисует родной хвост. */
export function doneP(order: SpeechOrder | null | undefined, base: string, p?: string): string {
  const off = deliveryOff(order);
  let html = off === null ? base : esc(uiText(off));
  const settings = !!p && order?.status === 'done' && studioDeliveryView(order) === 'settings';
  const missing = order?.status === 'done' && !order.result?.available;
  if (settings) html += `</p><button type="button" class="ar-lnk" data-${p}-settings>${esc(uiText('Настройки'))}</button>`;
  if (missing) html += `${settings ? '' : '</p>'}<p>${esc(uiText(UNAVAILABLE))}`;
  else if (settings) html += '<p hidden>';
  return html;
}

/** foot BotRun: главное действие итога — «Открыть в чате» с атрибутом экрана (data-<p>-chat). Подпись — функция: хвост живёт дольше
    языка профиля. foot.done задан, поэтому BotRun не вешает свой слушатель data-run-chat с подсказкой шаблона */
export function chatFoot(base: Record<string, unknown>, p: string): Record<string, unknown> {
  return { ...base, done: [`data-${p}-chat`, 'send', () => uiText('Открыть в чате')] };
}

/** Нажатие «Открыть в чате» (data-<p>-chat) на итоге: заказ просмотрен; в Telegram мини-приложение закрывается, вне Telegram —
    подсказка: бот сам не присылает — текст доставки, иначе text экрана («Тут откроется тема чата, куда бот прислал кружок») */
export function chatClick(o: { order: SpeechOrder | null | undefined; el: Element; text: string; tip(el: Element, text: string): void }): void {
  markSeen(o.order?.id);
  if (platform.kind === 'telegram') {
    platform.close();
    return;
  }
  o.tip(o.el, uiText(deliveryOff(o.order) ?? o.text));
}

/** Ссылка «Настройки» подписи итога (data-<p>-settings): раздел настроек, как у родного хвоста */
export function openSettings(): void {
  window.location.hash = '#settings';
}
